import { z } from 'zod';

export const userLanguageSkillsOptionsSchema = z.object({
    canEditLanguages: z.boolean(),
    canReadLanguages: z.boolean(),
});

export type UserLanguageSkillsOptions = z.infer<typeof userLanguageSkillsOptionsSchema>;
